import React from 'react';

import { useConnectModal } from '@particle-network/btc-connectkit';

import { useBtcWallet } from '@/networks/btc-like/btc';
import { useHeaderWalletDrawerStore } from '@/shared';

import HeaderWalletDrawerBtcWalletConnect from './HeaderWalletDrawerBtcWalletConnect';
import HeaderWalletDrawerBtcWalletDetails from './HeaderWalletDrawerBtcWalletDetails';

const HeaderWalletDrawerBtcWallet: React.FC = () => {
  const setIsDrawerOpen = useHeaderWalletDrawerStore((s) => s.setIsDrawerOpen);
  const { openConnectModal } = useConnectModal();
  const { isConnected } = useBtcWallet();

  if (isConnected) {
    return <HeaderWalletDrawerBtcWalletDetails />;
  }

  return (
    <HeaderWalletDrawerBtcWalletConnect
      className="h-14 w-full rounded-xl text-base"
      onClick={(e) => {
        e.stopPropagation();
        setIsDrawerOpen(false);
        openConnectModal?.();
      }}
    />
  );
};

export default HeaderWalletDrawerBtcWallet;
